import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Routes from "./routes";
import { AnimatePresence } from "framer-motion";
import "./App.scss";
import HeaderMenu from "./components/HeaderMenu";
import FooterLine from "./components/FooterLine";

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        <header>
          <HeaderMenu />
        </header>
        <Route
          render={({ location }) => (
            <AnimatePresence exitBeforeEnter initial={false}>
              <Routes location={location} key={location.pathname}></Routes>
            </AnimatePresence>
          )}
        />
        <footer>
          <FooterLine></FooterLine>
        </footer>
      </div>
    </Router>
  );
}

export default App;
